export enum RankRoutes {
  ROOT = '',
  QA = 'qa'
}
